import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import AppLoadingView from "../Common/AppLoadingView";
import LoadingViewIcon from "@mui/icons-material/Fingerprint";

const Callback = () => {
  const navigate = useNavigate();
  const { exchangeCodeForTokens } = useAuth();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await exchangeCodeForTokens(code);

        // Restore redirect intent
        const stored = sessionStorage.getItem("post_login_redirect");
        sessionStorage.removeItem("post_login_redirect");

        if (stored) {
          const { pathname, search = "", hash = "" } = JSON.parse(stored);

          navigate(
            `${pathname}${search}${hash}`,
            { replace: true }
          );
        } else {
          // Safe default
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error("OAuth callback failed", error);
        sessionStorage.removeItem("post_login_redirect");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeCodeForTokens, navigate]);

  return <AppLoadingView
    title="Signing you in"
    description="We are securely verifying your session and preparing your workspace."
    icon={LoadingViewIcon}
  />
};

export default Callback;